<div class="content-wrapper">

    <section class="content-header" id="viewOn">
        <h1>
            Prestação de contas
            <small>Criar, listar e editar</small>
        </h1>
        <ol class="breadcrumb">
            <li>
                <a routerLink="/home">
                    <i class="fa fa-home"></i> Home</a>
            </li>
            <li class="active">Prestação de contas</li>
        </ol>
    </section>

    <br>

    <div class="col-md-12">
        <div class="box box-primary">
            <div class="box-header with-border">
                <h3 class="box-title">Gerenciar conteúdo</h3>
            </div>

            <div class="box-body no-padding">

                <div class="col-xs-12">
                    <h3>Opções</h3>
                    <hr>
                    <div class="col-md-12">
                        <button class="btn btn-app animated fadeInDown" pTooltip="Convênios em Execução"
                            tooltipPosition="top" [routerLink]="['/prestacao-contas/listar', 'convenios']"
                            routerLinkActive="btn-app-active">
                            <i class="fas fa-retweet"></i> Convênios
                        </button>
                        <button class="btn btn-app animated fadeInDown" pTooltip="Parcerias em Execução"
                            tooltipPosition="top" [routerLink]="['/prestacao-contas/listar', 'parcerias']"
                            routerLinkActive="btn-app-active">
                            <i class="far fa-thumbs-up"></i> Parcerias
                        </button>
                        <!-- <button class="btn btn-app animated fadeInDown" pTooltip="Projetos de Inovação em execução" tooltipPosition="top" routerLink="#">
                            <i class="far fa-file-alt"></i> Inovação
                        </button> -->
                        <!-- <button class="btn btn-app animated fadeInDown" pTooltip="Projetos da plataforma SIGMA em execução" tooltipPosition="top" routerLink="#">
                            <i class="far fa-file-alt"></i> Sigma
                        </button>  -->
                        <!-- <button class="btn btn-app animated fadeInDown" pTooltip="Projetos de credenciamento de emrpesas em execução" tooltipPosition="top" routerLink="#">
                            <i class="far fa-file-alt"></i> Credenciamento
                        </button>  -->
                    </div>

                </div>

                <div class="col-sm-12">
                    <hr>
                </div>

                <div class="col-sm-12">
                    <router-outlet (activate)="showDefaultMessage=true">
                        <div class="col-sm-12" *ngIf="!showDefaultMessage">
                            <h3 class="text-muted">Selecione a opção desejada.</h3>
                            <br>
                        </div>
                    </router-outlet>
                </div>

            </div>

            <br>

        </div>

    </div>